import { Play, Pause, ChevronLeft, ChevronRight, SkipForward, SkipBack } from "lucide-react"
import "../styles/step-controls.css"
import Button from "../../shared/Button"

export default function StepControls({
  step,
  maxSteps,
  onStepForward,
  onStepBackward,
  onSkipToStart,
  onSkipToEnd,
  autoPlay,
  toggleAutoPlay,
}) {
  return (
    <div className="tspstep-controls">
      <h3>Step Controls</h3>

      <div className="tspstep-progress">
        <div className="tspstep-count">
          Step {step} of {maxSteps}
        </div>
        <div className="tsp-progress-bar">
          <div className="tsp-progress-fill" style={{ width: `${maxSteps ? (step / maxSteps) * 100 : 0}%` }}></div>
        </div>
      </div>

      <div className="tspstep-buttons">
        <Button variant="secondary" size="sm" onClick={onSkipToStart} disabled={step <= 1} title="Go to first step">
          <SkipBack size={18} />
        </Button>

        <Button variant="secondary" size="sm" onClick={onStepBackward} disabled={step <= 1} title="Previous step">
          <ChevronLeft size={18} />
        </Button>

        <Button onClick={toggleAutoPlay} title={autoPlay ? "Pause" : "Play"}>
          {autoPlay ? <Pause size={18} /> : <Play size={18} />}
        </Button>

        <Button variant="secondary" size="sm" onClick={onStepForward} disabled={step >= maxSteps} title="Next step">
          <ChevronRight size={18} />
        </Button>

        <Button variant="secondary" size="sm" onClick={onSkipToEnd} disabled={step >= maxSteps} title="Go to last step">
          <SkipForward size={18} />
        </Button>
      </div>

      <div className="tspstep-hint">Use the controls to navigate through the algorithm steps</div>
    </div>
  )
}
